import { Component, Input, OnChanges } from '@angular/core';
import { EsgConstants } from '@ddt-web/config';
import { InjectConfig, PcConfigKey } from '@ddt-web/config-layer';
import { CellData, CellUtil, ColumnConfig, ColumnText, ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import * as cloneDeep from 'lodash/cloneDeep';
import * as groupBy from 'lodash/groupBy';

@Component({
	selector: 'esg-holding-rankings-portfolio-data',
	templateUrl: './esg-holding-rankings-portfolio-data.component.html',
	styleUrls: ['./esg-holding-rankings-portfolio-data.component.scss']
})
export class EsgHoldingRankingsPortfolioDataComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public tabs: TabData[];
	@Input() public disclosureKey: string;
	@Input() public shouldShowNoDataComponent: boolean = true;
	@Input() public singlePortColumnProportions: number[];
	@Input() public multiPortColumnProportions: number[];
	@InjectConfig(PcConfigKey.SHOW_AS_OF_DATE_DYNAMIC) public readonly showAsOfDateDynamic: boolean = EsgConstants.SHOW_AS_OF_DATE_DYNAMIC_DEFAULT;
	@Input() public asOfDate: string;

	public isValid: boolean = false;
	public portfolioWiseTab: TabData[] = [];
	public selectedPortfolioIndex: number = 0;

	public ngOnChanges(): void {
		if (this.data.success) {
			const { portfolioWiseTab, overallTab } = groupBy(cloneDeep(this.tabs),
				(tab: TabData) => {
					if (tab.config.id.includes('overall')) { return 'overallTab'; }
					return 'portfolioWiseTab';
				});
			this.portfolioWiseTab = portfolioWiseTab;
			if (this.data?.portfolioData?.length > 1 && this.portfolioWiseTab.every(tab => TabUtil.isTabValid(tab))) {
				this.combineTableData(this.portfolioWiseTab, overallTab[0]);
			} else {
				this.portfolioWiseTab = overallTab;
			}
			this.isValid = this.portfolioWiseTab.every(tab => TabUtil.isTabValid(tab) && !TabUtil.isEmptyTab(tab));
		} else {
			this.isValid = false;
		}
	}

	private combineTableData(portfolioWiseTabData: TabData[], overallTabData: TabData): void {
		if (TabUtil.isTabValid(overallTabData) && !TabUtil.isEmptyTab(overallTabData)) {
			portfolioWiseTabData[0].tableData.unshift(overallTabData.tableData[0]);
		}
		if (!this.data.portfolioData.some(portfolio => portfolio.field?.name?.formattedValue === 'Overall')) {
			this.data.portfolioData.unshift(CellUtil.getCellRow([new CellData(new ColumnConfig(new ColumnText('name'), null, null, 'name'), 'Overall', 'Overall')]));
		}
	}
}
